import { Text } from '@ltvco/refresh-lib/theme';
import { InfoOutlined } from '@mui/icons-material';

import {
  InlineLoading,
  ErrorStateContainer,
  IconWrapper,
  OpinionListContainer,
  OpinionListEmptyState,
  OpinionListDisclaimer,
  OpinionListDisclaimerText,
  OpinionListContent,
} from '../../../shared';
import { type DisplayOpinion } from '../../../types';
import { OpinionContent } from '../OpinionContent';

interface OpinionsListProps {
  clusterOpinions: DisplayOpinion[];
  error?: string;
  isLoading?: boolean;
}

export const OpinionsList = ({
  clusterOpinions,
  error,
  isLoading = false,
}: OpinionsListProps) => {
  if (isLoading) {
    return <InlineLoading />;
  }

  if (error) {
    return (
      <ErrorStateContainer>
        <Text color="error">Error loading opinions</Text>
      </ErrorStateContainer>
    );
  }

  return (
    <OpinionListContainer>
      {clusterOpinions.length === 0 ? (
        <OpinionListEmptyState>
          <Text variant="h2" color="text.secondary">
            No opinion found.
          </Text>
        </OpinionListEmptyState>
      ) : (
        <>
          <OpinionListDisclaimer>
            <IconWrapper size={24}>
              <InfoOutlined />
            </IconWrapper>
            <OpinionListDisclaimerText>
              The text of these documents could have been obtained by analyzing
              a scanned document and may have typos.
            </OpinionListDisclaimerText>
          </OpinionListDisclaimer>
          <OpinionListContent>
            {clusterOpinions.map((opinion) => (
              <OpinionContent key={opinion.id} opinion={opinion} />
            ))}
          </OpinionListContent>
        </>
      )}
    </OpinionListContainer>
  );
};
